export default function ArtifactsPage() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Artifacts</h1>
      <p>Manage your artifacts here.</p>
    </div>
  );
}
